import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { ConvenioService } from '../../../../../providers/convenio-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';

import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-resumo-relatorio-inspecao-convenios',
  templateUrl: 'resumo-relatorio-inspecao.html',
  providers: [
    ConvenioService
  ]
})
export class ResumoRelatorioInspecaoConveniosPage extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "2001";

  order: string = 'nrProcesso';
  reverse: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public convenioService: ConvenioService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(6);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = false;
      this.order = "-" + value;
    } else {
      this.reverse = true;
      this.order = value;
    }
  }

  carregarDados() {
    this.convenioService.obterDadosResumoRelatorioInspecao().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  voltar() {
    this.menuService.redirecionarPagina(this.convenioService.obterIdPaginaConvenio());
  }

  salvarComentario() {
    if (this.listaDados) {
      this.listaDados.resultado = this.capitalize(this.listaDados.resultado);
      this.convenioService.salvarDadosResumoRelatorioInspecao(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.voltar();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      });
    }
  }

  submeterNoCertificado() {
    if (this.listaDados.resumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resumoAnalise == null || this.listaDados.resumoAnalise == undefined || !this.listaDados.resumoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
    } else {
      if (this.listaDados) {

        var jsonSubmeter = {
          "idModuloAnalise": this.listaDados.idModuloAnalise,
          "dsResultadoAnalise": this.capitalize(this.listaDados.resumoAnalise)
        }

        this.convenioService.submeterAnalise(jsonSubmeter, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
        });
      }
    }
  }

  baixarRelatorioCompleto(idDoc) {
    this.convenioService.obterArquivoResumoRelatorioInspecao(idDoc);
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }

  formatarProcesso(processo) {
    if (processo) {
      let a = processo.substr(0,4) + "/" + processo.substr(4,5) + "-" + processo.substr(9,1);
      return a; 
    }

    return "N/A";
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/convenio-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao.ts